import axios from "axios";
import { authHeader } from "./headerConfig";
const API_ENDPOINT = process.env.REACT_APP_ENDPOINT + "/api/x-admin";

// main product
const getAllProducts = async (page = 1) => {
    const response = await axios.get(`${API_ENDPOINT}/items?page=${page}`, {
        withCredentials: true,
        headers: {
            ...authHeader(),
            Accept: "application/json",
        },
    });
    return response.data;
};

// main product
const getProduct = id => {
    return axios.get(API_ENDPOINT + "/items/" + id, {
        withCredentials: true,
        headers: {
            ...authHeader(),
            Accept: "application/json",
        },
    });
};
// main product
const createProduct = (data, categoryId) => {
    return axios.post(`${API_ENDPOINT}/categories/${categoryId}/items`, data, {
        withCredentials: true,
        headers: {
            ...authHeader(),
            Accept: "application/json",
        },
    });
};
const deleteProduct = id => {
    return axios.delete(`${API_ENDPOINT}/items/${id}`, {
        withCredentials: true,
        headers: {
            ...authHeader(),
            Accept: "application/json",
        },
    });
};
const addSubProduct = (data, id) => {
    return axios.post(`${API_ENDPOINT}/items/${id}/subitems`, data, {
        withCredentials: true,
        headers: {
            ...authHeader(),
        },
    });
};
const editProduct = (data, id) => {
    return axios.put(`${API_ENDPOINT}/items/${id}`, data, {
        withCredentials: true,
        headers: {
            ...authHeader(),
            Accept: "application/json",
        },
    });
};
const editProductImage = (data, id) => {
    return axios.post(`${API_ENDPOINT}/items/${id}/image`, data, {
        withCredentials: true,
        headers: {
            ...authHeader(),
        },
    });
};
const deleteSubProduct = id => {
    return axios.delete(`${API_ENDPOINT}/subitems/${id}`, {
        withCredentials: true,
        headers: {
            ...authHeader(),
            Accept: "application/json",
        },
    });
};
const getSubProduct = async id => {
    const response = await axios.get(`${API_ENDPOINT}/subitems/${id}`, {
        withCredentials: true,
        headers: {
            ...authHeader(),
            Accept: "application/json",
        },
    });
    return response.data;
};
const editSubProduct = (data, id) => {
    return axios.put(`${API_ENDPOINT}/subitems/${id}`, data, {
        withCredentials: true,
        headers: {
            ...authHeader(),
            Accept: "application/json",
        },
    });
};
const editSubProductImage = (data, id) => {
    return axios.post(`${API_ENDPOINT}/subitems/${id}/image`, data, {
        withCredentials: true,
        headers: {
            ...authHeader(),
        },
    });
};
const getSubProducts = async (id, page = 1) => {
    const response = await axios.get(
        `${API_ENDPOINT}/items/${id}/subitems?page=${page}`,
        {
            withCredentials: true,
            headers: {
                ...authHeader(),
                Accept: "application/json",
            },
        }
    );
    return response.data;
};
const productServices = {
    getAllProducts,
    createProduct,
    getSubProducts,
    getProduct,
    deleteProduct,
    editProduct,
    editProductImage,
    deleteSubProduct,
    addSubProduct,
    getSubProduct,
    editSubProduct,
    editSubProductImage,
};

export default productServices;
